// extracted by mini-css-extract-plugin
export var dateLabel = "_44-0";
export var dateLabelError = "_44-1";
export var fullWidth = "_44-2";
export var smaller = "_44-3";